import API from '../.';

const me = () => API.get('/api/v1/users/me/');

export default me;
